
// send wishlist info to marketing cloud
$(document).ready(() => {
    $('body').on('sfmcWishlistTrack', (e, data) => {
        if (data) {
            let wishlistItem = {items: data, skus:data};
            _etmc.push(['trackWishlist', wishlistItem]);
        } else {
            _etmc.push(['trackWishlist', {items:[], skus: [], }]);
        }
    });
});
